import { BIRTH_COUNTRIES } from "@/data/birthPlaceCountries";

/** Convert a flag emoji like "🇨🇬" to its 2-letter ISO code ("CG"). */
function flagToIsoCode(flag: string): string | null {
  try {
    const codePoints = Array.from(flag).map((c) => c.codePointAt(0) || 0);
    if (codePoints.length < 2) return null;
    const base = 0x1f1e6;
    const a = codePoints[0] - base;
    const b = codePoints[1] - base;
    if (a < 0 || a > 25 || b < 0 || b > 25) return null;
    return String.fromCharCode(65 + a) + String.fromCharCode(65 + b);
  } catch {
    return null;
  }
}

/**
 * From a "City, Country" birth place string, derive the ISO 2-letter
 * country code matching the country part. Returns null if not found.
 */
export function deriveBirthCountryCode(birthPlace: string): string | null {
  if (!birthPlace) return null;
  const parts = birthPlace.split(",").map((s) => s.trim());
  const countryName = parts[1] || parts[0];
  if (!countryName) return null;
  const entry = BIRTH_COUNTRIES.find((c) => c.name === countryName);
  if (!entry) return null;
  return flagToIsoCode(entry.flag);
}